import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import {green, amber} from "@material-ui/core/colors";
import {withStyles} from "@material-ui/core/styles";
import withMobileContext from "../../decorators/withMobileContext";

const styles = (theme) => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: `flex`,
    alignItems: `center`
  },
  messageText: {
    margin: `0 0 0 10px`
  },
  content: {
    flexWrap: `nowrap`
  }
});

class Message extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    type: PropTypes.string,
    text: PropTypes.string,
    isMobile: PropTypes.bool
  };
  state = {
    isOpen: true
  };
  handleClose = () => {
    this.setState({
      isOpen: false
    });
  };
  render() {
    const {type, text, classes, className, isMobile} = this.props;
    return (
      <div className={`message${type ? ` message_${type}` : ``}`}>
        <Snackbar
          anchorOrigin={{
            vertical: `bottom`,
            horizontal: `left`
          }}
          onClose={
            type !== `error` && type !== `warning` ? this.handleClose : null
          }
          open={this.state.isOpen}
          autoHideDuration={
            isMobile && type !== `error` && type !== `warning` ? 4000 : null
          }
        >
          <SnackbarContent
            className={classNames(classes.content, classes[type], className)}
            message={
              <span className={classes.message}>
                {this.getIconForMessage(type)}
                <span className={classes.messageText}>{text}</span>
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.handleClose}
              >
                <CloseIcon className={classes.icon} />
              </IconButton>
            ]}
          />
        </Snackbar>
      </div>
    );
  }
  getIconForMessage(type) {
    switch (type) {
      case `error`:
        return <ErrorIcon />;
      case `info`:
        return <InfoIcon />;
      case `warning`:
        return <WarningIcon />;
      case `success`:
        return <CheckCircleIcon />;
    }
    return void 0;
  }
}

export default withStyles(styles)(withMobileContext(Message));
